var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12", md: "4", "ma-1": "" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "title font-weight-black" }, [
            _vm._v("\n            Contact i-escape\n        "),
          ]),
          _vm._v(" "),
          _c("v-card-text", [
            _c("p", [
              _c("a", { attrs: { href: "mailto:channels@i-escape.com" } }, [
                _vm._v("channels@i-escape.com"),
              ]),
              _vm._v(
                " for channel management, iCal feeds and rate/availability updates"
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("a", { attrs: { href: "mailto:reservations@i-escape.com" } }, [
                _vm._v("reservations@i-escape.com"),
              ]),
              _vm._v(" for the reservations department"),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("a", { attrs: { href: "mailto:help@i-escape.com" } }, [
                _vm._v("help@i-escape.com"),
              ]),
              _vm._v(" for general help"),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }